export default __webpack_public_path__ + "static/media/agusd.ee54c043.svg";